import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { compose } from 'redux';

import { reloadViewer } from 'common/actions/viewer';
import LoginForm from 'common/auth/LoginForm';
import { ViewerContext } from 'common/containers/ViewerContainer';
import connect from 'common/core/connect';
import SignInHelmet from 'common/helmets/SignInHelmet';
import Link from 'common/Link';
import devURL from 'common/util/devURL';
import isExpectedURLOrigin from 'common/util/isExpectedURLOrigin';
import withContexts from 'common/util/withContexts';

import 'css/components/_SignIn.scss';

class SignIn extends Component {
  static propTypes = {
    location: PropTypes.object,
    router: PropTypes.object.isRequired,
    viewer: PropTypes.object,
  };

  componentWillMount() {
    const { router, viewer } = this.props;
    if (viewer && !viewer.loggedOut) {
      if (viewer.companies && viewer.companies.length === 0) {
        router.replace('/register');
      }
    }
  }

  componentDidMount() {
    const { viewer } = this.props;
    if (viewer && !viewer.loggedOut) {
      if (viewer.companies && viewer.companies.length > 0) {
        const redirectURL = this.getRedirectURL(viewer);
        window.location.assign(redirectURL);
      }
    }
  }

  getRedirectURL = (userWithCompanies) => {
    const {
      location: { query },
    } = this.props;
    const redirect = query.redirect && decodeURIComponent(query.redirect);
    const docsOrigin = devURL('https://developers.canny.io');

    if (redirect && redirect.startsWith(docsOrigin) && isExpectedURLOrigin(redirect, docsOrigin)) {
      return redirect;
    }

    const company =
      userWithCompanies.companies.find((c) => !c.integrationAuthRedirectionURL) ??
      userWithCompanies.companies[0];

    if (company.integrationAuthRedirectionURL) {
      return company.integrationAuthRedirectionURL;
    }

    if (redirect) {
      const origin = devURL('https://' + company.subdomain + '.canny.io');
      const url = `${origin}${redirect}`;
      if (isExpectedURLOrigin(url, origin)) {
        return url;
      }
    }

    return devURL('https://' + company.subdomain + '.canny.io/admin');
  };

  onSuccess = (user) => {
    const { companies } = user;

    if (!companies.length) {
      this.props.reloadViewer().then(() => {
        const { router } = this.props;
        router.push('/register');
      });
      return;
    }

    const redirectURL = this.getRedirectURL(user);
    window.location.assign(redirectURL);
  };

  render() {
    return (
      <div className="signIn">
        <SignInHelmet />
        <div className="signInContainer">
          <h1>Log in to your account</h1>
          <LoginForm onSuccess={this.onSuccess} />
        </div>
        <Link className="signUpLink" to="/register">
          Don't have an account? Sign up
        </Link>
      </div>
    );
  }
}

export default compose(
  connect(null, (dispatch) => ({
    reloadViewer: () => {
      return Promise.all([dispatch(reloadViewer())]);
    },
  })),
  withContexts(
    {
      viewer: ViewerContext,
    },
    {
      forwardRef: true,
    }
  )
)(SignIn);
